module.exports = __webpack_public_path__ + "static/media/239.40ad788a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/239.jpg
// module id = 962
// module chunks = 0